import React, { createContext, useContext } from 'react'

import { PopupControls } from 'shared/hooks/usePopupControls'

import { DropdownHorizontalPosition, DropdownVerticalPosition } from 'components/UIKit/Dropdown'

import { CalendarValue, DatePickerVariant, IntervalVariants } from '../types'

type DatePickerContextState = {
  controlDate: Date
  nextControlDate: (e: React.SyntheticEvent) => void
  prevControlDate: (e: React.SyntheticEvent) => void

  startRange: Date | null
  endRange: Date | null
  selectStartRange: (date: Date | null) => void
  selectEndRange: (date: Date | null) => void
  selectDate: (date: Date | null) => void
  setControlDate: (date: Date) => void

  interval: IntervalVariants
  changeInterval: (interval: IntervalVariants) => void

  variant: DatePickerVariant

  value: CalendarValue
  modalControls: PopupControls
  onChange: (value: CalendarValue) => void

  reset: () => void
  horizontalPosition?: DropdownHorizontalPosition
  verticalPosition?: DropdownVerticalPosition
  disabledDates?: Date[]
  maxDate?: Date
  minDate?: Date
  intervals?: IntervalVariants[]
  isInputAvailable?: boolean
  onError?: (error: string) => void
}

const DatePickerContext = createContext({} as DatePickerContextState)

const useDatePickerContext = () => useContext(DatePickerContext)

export { DatePickerContext, useDatePickerContext }
